import { render } from "./FridgeDetailsMyAssistListItem.vue?vue&type=template&id=e6cb0788&scoped=true&ts=true"
import script from "./FridgeDetailsMyAssistListItem.vue?vue&type=script&lang=ts"
export * from "./FridgeDetailsMyAssistListItem.vue?vue&type=script&lang=ts"

import "./FridgeDetailsMyAssistListItem.vue?vue&type=style&index=0&id=e6cb0788&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6cb0788"]])

export default __exports__